/** Persisted chart UI preferences (timeframe, type, colors) shared by TvChart and menu modals. */

export const CHART_PREF_EVENT = "fx-chart-prefs-changed";
const STORAGE_KEY = "fxbazzar_chart_prefs";

export const TIMEFRAME_OPTIONS = [
  { id: "1m", label: "1m" },
  { id: "5m", label: "5m" },
  { id: "15m", label: "15m" },
  { id: "1h", label: "1h" },
  { id: "1d", label: "1D" },
];

export const CHART_TYPE_OPTIONS = [
  { id: "candle", label: "Candle" },
  { id: "line", label: "Line" },
  { id: "ohlc", label: "OHLC" },
  { id: "area", label: "Area" },
];

export const COLOR_TEMPLATES = [
  {
    id: "default",
    label: "FxBazzar Default",
    shortLabel: "Green & Red",
    upColor: "#089981",
    downColor: "#f23645",
  },
  {
    id: "classic",
    label: "Classic Teal / Red",
    shortLabel: "Teal & Red",
    upColor: "#26a69a",
    downColor: "#ef5350",
  },
  {
    id: "blue-orange",
    label: "Blue / Orange",
    shortLabel: "Blue & Orange",
    upColor: "#2962FF",
    downColor: "#FF6D00",
  },
  {
    id: "forest",
    label: "Forest / Crimson",
    shortLabel: "Forest & Crimson",
    upColor: "#15803d",
    downColor: "#dc2626",
  },
  {
    id: "mono",
    label: "Monochrome",
    shortLabel: "Neutral",
    upColor: "#64748b",
    downColor: "#1e293b",
  },
];

export const DEFAULT_CHART_PREFS = {
  defaultTimeframe: "1m",
  defaultChartType: "candle",
  showVolume: true,
  crosshairMagnet: true,
  colorTemplateId: "default",
};

export function getColorTemplate(id) {
  return COLOR_TEMPLATES.find((t) => t.id === id) || COLOR_TEMPLATES[0];
}

export function loadChartPreferences() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return { ...DEFAULT_CHART_PREFS };
    const parsed = JSON.parse(raw);
    return { ...DEFAULT_CHART_PREFS, ...parsed };
  } catch {
    return { ...DEFAULT_CHART_PREFS };
  }
}

export function saveChartPreferences(partial, { broadcast = true } = {}) {
  const current = loadChartPreferences();
  const merged = { ...current, ...partial };
  const next = {
    ...merged,
    defaultTimeframe: TIMEFRAME_OPTIONS.some((t) => t.id === merged.defaultTimeframe)
      ? merged.defaultTimeframe
      : DEFAULT_CHART_PREFS.defaultTimeframe,
    defaultChartType: CHART_TYPE_OPTIONS.some((t) => t.id === merged.defaultChartType)
      ? merged.defaultChartType
      : DEFAULT_CHART_PREFS.defaultChartType,
  };
  localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  if (broadcast && typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent(CHART_PREF_EVENT, { detail: next }));
  }
  return next;
}
